module.exports = __webpack_public_path__ + "img/zs5.d828894a.jpg";